import { useState, useEffect } from "react";
import { useDeleteConfirmation } from "../../components/common";

import PageBodyWrapper from "../../components/PageBodyWrapper";
import ColorModal from "./modal";
import useApi from "../../api";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../redux/rootReducer";

import { fetchColors } from "../../redux/colorsSlice";
import { Link } from "react-router-dom";
import GenericSelectableTable from "../../components/selectableTable";
import { toast } from "react-toastify";

function Color() {

    const colors = useSelector((state: RootState) => state.colors);
    const [edit, setEdit] = useState<any>();
    const [openModal, setOpenModal] = useState(false)

    const api = useApi();
    const dispatch = useDispatch()

    const { handleDelete } = useDeleteConfirmation();
    
    const getColors = () => {
        dispatch(fetchColors() as any);
    };

    const onModalOpen = (editId?: number) => {
        setOpenModal(!openModal);
        if (editId) {
            setEdit(editId);
        }
    };

    const onModalClose = () => {
        setOpenModal(!openModal);
        setEdit('');
    };

    const onModalSubmit = () => {
        getColors();
    };


    useEffect(() => {
        if (!colors.results.length) {
            dispatch(fetchColors() as any);
        }
    }, []);

    const columns = [
        { header: "ID", key: "id", render: (item: any) => (
          <Link to={item.id}>
            <p>{item.id}</p>
            <p className="text-sm font-normal text-base-300 mt-1">#ID{item.id}</p>
          </Link>
        )},
        {
            header: "Name", key: "name"
        },
        {
            header: "Color", key: "code"
        }
    ]

    const bullkActionButtons = [
        {
          label: 'Delete Selected',
          onClick: (selectedItems:any) => {
            toast.success(`Delete items: ${Array.from(selectedItems)}`);
            // Implement delete logic here
          },
        },
        {
          label: 'Export Selected',
          onClick: (selectedItems:any) => {
            toast.success(`Export items: ${Array.from(selectedItems)}`);
            // Implement export logic here
          },
        },
      ];

    return (
        <>
            <div className="flex justify-between pl-[5%] pt-[5%] md:pl-10 md:pr-10 md:pt-10">
                <div></div>
                <div>
                    <button
                    className="text-white bg-primary-600 px-10 py-3 rounded-xl font-nunito font-[900]"
                    onClick={(e) => onModalOpen()}
                    >
                    Add Color
                    </button>
                    
                </div>
                
            </div>
            
            <PageBodyWrapper>
                <div className="relative overflow-x-auto px-1 pt-2">
                    <GenericSelectableTable columns={columns} data={colors.results} bullkActionButtons={bullkActionButtons} />
                </div>
            </PageBodyWrapper>

            {openModal && <ColorModal  isOpen={openModal} edit={edit} onClose={onModalClose} onSubmit={onModalSubmit} /> }
        </>
    );
}

export default Color;
